import {
    DokumentApiDto,
    LieferantDetailApiDto,
    SelectListItemApiDto,
    TeilnehmerListApiDto,
    TvsKundeDetailApiDto,
    TvsKundeListApiDto,
    TvsLieferantFehlerhafteRechnungApiDto,
    TvsLieferantRechnungApiDto,
    TvsLieferantRechnungDetailApiDto
} from '@/api-schema';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { LieferantenDokumentFilterDto } from '@/types/LieferantenDokumentFilterDto';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';

export interface ILieferantenState {
    rechnungList: Array<TvsLieferantRechnungApiDto>;
    rechnungenDetails: Array<TvsLieferantRechnungDetailApiDto>;
    rechnungFilter: RechnungFilterDto;
    loading: boolean;
    totalNumberOfRecords: number | null;
    tvsKundenFilter: TeilnehmerFilterDto;
    tvsKundenVonLieferant: Array<object>;
    tvsKundenListe: Array<TvsKundeListApiDto>;
    tvsKundenTotalNumberOfRecords: number | null;
    tvsKundenLoading: boolean;
    lieferantenDokumentFilter: LieferantenDokumentFilterDto;
    lieferantenDokumentList: Array<DokumentApiDto>;
    lieferantenDokumenteTotalNumberOfRecords: number | null;
    dokumenteLoading: boolean;
    fehlerhafteRechnungList: Array<TvsLieferantFehlerhafteRechnungApiDto>;
    lieferantDetailData: LieferantDetailApiDto;
    tvsKundeDetails: TvsKundeDetailApiDto;
    unitsOfMeasurement: SelectListItemApiDto[];
    mwstSatzList: SelectListItemApiDto[];
}

export const state: ILieferantenState = {
    loading: false,
    totalNumberOfRecords: null,
    rechnungList: [],
    rechnungenDetails: [],
    rechnungFilter: new RechnungFilterDto(),
    tvsKundenVonLieferant: [],
    tvsKundenListe: [],
    tvsKundenTotalNumberOfRecords: null,
    tvsKundenLoading: false,
    tvsKundenFilter: new TeilnehmerFilterDto(),
    lieferantenDokumentFilter: new LieferantenDokumentFilterDto(),
    lieferantenDokumentList: [],
    lieferantenDokumenteTotalNumberOfRecords: null,
    dokumenteLoading: false,
    fehlerhafteRechnungList: [],
    lieferantDetailData: new Object(),
    tvsKundeDetails: new Object(),
    unitsOfMeasurement: [],
    mwstSatzList: []
};
